import RenderSvg from "../../components/RenderSvg";
import React, { useContext, useEffect } from "react";
import JourneyConfig from "../../context/JourneyConfig";
import Footer from "../../components/Footer";
import { ArrowPathIcon } from "@heroicons/react/16/solid";
import Head from "../Head";
function GenericError({stepperFunc, onNextStep, color,  errorHandlerTexts, config }) {
    const { journey, getJourney } = useContext(JourneyConfig);
    const handleRefresh = async () => {
    sessionStorage.removeItem("error");
    if (!journey) {
      await getJourney(sessionStorage.getItem("jId"));
    }
    stepperFunc(
      sessionStorage.getItem("currentStep")
        ? parseInt(sessionStorage.getItem("currentStep"))
        : 0
    );
  };
  useEffect(() => {
      return () => {
        sessionStorage.removeItem("errorCategory");
        sessionStorage.removeItem("errorReason");
      };
    }, []);
  return (
    <>
       <Head
        style={{ zIndex: "100" }}
        onNextStep={onNextStep}
        showLanguages={false}
        showMobileFlow={false}
        showHelp={false}
        showCountry={false}
        stepperFunc={stepperFunc}
      />

      <div className="parent-container">
        <div className="main">
          <div className="left-section">
            <RenderSvg
              config={config}
              id={"analusing"}
              svgType={"error"}
              className="w-[180px] h-[180px] md:w-[200px] md:h-[200px] md:relative fixed"
              style={{ marginTop: "3rem" }}
            />
          </div>

          <div
            className="right-section md:items-start items-center"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              gap: 24,
              fontFamily: "Inter, sans-serif",
            }}
          >
            <div
              className="flex flex-col items-start justify-center w-full"
              style={{ height:  "auto" }}
            >   
                <>
                  <div className="flex flex-col items-">
                    <div className="text-[18px] md:text-[28px] font-semibold text-[#000000] text-center md:text-left">
                      {errorHandlerTexts.heading}
                    </div>
                    <div className="mt-3 text-[12px] md:text-[16px] font-semibold text-[#656565]  text-center md:text-left">
                      {errorHandlerTexts.subHeading1}
                      <br />
                      <br />
                      {errorHandlerTexts.subHeading2}
                    </div>
                  </div>
                </>  
            </div>

            {/* Try again button */}
            <div className="w-full">
              <div className="flex flex-col w-full justify-center items-center">
                <button
                  className="flex flex-row text-[14px] items-center justify-center gap-4 w-full text-white py-4 px-4 rounded mt-6 md:mt-0"
                  style={{
                    backgroundColor: config?.branding?.accentColor ?? "#1658aa",
                  }}
                  onClick={handleRefresh}
                >
                  {errorHandlerTexts.button}
                  <ArrowPathIcon className="h-5 w-5" />
                </button>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}


export default GenericError;
